import { Input, Modal, ModalBody, Spinner } from 'reactstrap';
import ErrorMessage from '../common/ErrorMessage';
import StatusIcon from '../Icons/StatusIcon';
import { useState } from 'react';
import Button from '../ui/Button';
interface IConfirmModalProps {
  isOpen: boolean;
  toggle: () => void;
  submitHandler: (actionType?: string, reason?: string) => void;
  isLoading: boolean;
  actionType: string;
}
const ApproveModal = ({
  isOpen,
  toggle,
  submitHandler,
  actionType,
  isLoading,
}: IConfirmModalProps) => {
  const [reason, setReason] = useState<string>('');
  const [error, setError] = useState<string>('');
  const handleSubmit = () => {
    if (actionType === 'reject') {
      if (reason.length === 0) {
        setError('Reason is required');
        return;
      }
      submitHandler(actionType, reason);
    } else {
      submitHandler(actionType);
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="text-center ">
        <div className="d-flex flex-column justify-items-center align-items-center gap-4">
          <span className={actionType == 'reject' ? 'icon' : 'icon-g'}>
            {actionType === 'reject' ? (
              <StatusIcon status="rejected" />
            ) : (
              <StatusIcon status="approved" />
            )}
          </span>

          {/* {!Reason && <h2>Are you sure ?</h2>} */}
          <p className="mb-4">
            Do you really want to{' '}
            {actionType === 'reject' ? 'Reject' : 'Approve'} ?
          </p>
          {actionType === 'reject' && (
            <div className="col-12">
              <div className="d-flex flex-column">
                <label htmlFor="firstName" className="form-label text-start">
                  Reason
                  <span className="text-danger">*</span>
                </label>
                <Input
                  type="text"
                  className=" w-100"
                  placeholder="Reason"
                  id="firstName"
                  aria-describedby="emailHelp"
                  onChange={(e) => {
                    if (e.target.value) {
                      setReason(e.target.value);
                      setError('');
                    }
                  }}
                />
                <ErrorMessage message={error} />
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="row m-0 w-100">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={toggle}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <Button
                className={`btn ${actionType === 'reject' ? 'btn-danger' : 'btn-success'} w-100 `}
                onClick={handleSubmit}
                disabled={isLoading}
                type="button"
              >
                {isLoading ? (
                  <Spinner color="light" />
                ) : actionType === 'reject' ? (
                  'Reject'
                ) : (
                  'Approve'
                )}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default ApproveModal;
